'use strict';

var $ = require('jquery'),
  Backbone = require('backbone'),
  config = require('../../js/config'),
  breakpoints = require('../../js/breakpoints'),

  Accordion = Backbone.View.extend({

    events: {
      'click h3.Accordion-heading': 'open'
    },

    initialize: function() {
      if (this.$el.hasClass('Accordion--mobile')) {
        this.isMobile = true;
      }
      if (this.$el.data('expandFaq') === 1) {
        $('h2.Accordion-heading').trigger('click');
      }
    },

    open: function(e) {
      if (!this.isMobile || breakpoints.isLessThan(config.breakpoint.phablet, true)) {
        var $target = $(e.currentTarget);

        $target.toggleClass('is-active');
        $target.next('.Accordion-body').slideToggle();
        var activeAnchorElement = e.currentTarget.querySelector('a');
        if (activeAnchorElement) {
          if (e.currentTarget.classList.contains('is-active')) {
            activeAnchorElement.setAttribute('aria-expanded', true);
            e.currentTarget.focus(e.target);
          }
          else {
            activeAnchorElement.setAttribute('aria-expanded', false);
          }
        }
      }

      return false;
    }

  }, {
    create: function($parent) {
      $parent.find('.js-Accordion').each(function(n, el) {
        new Accordion({
          el: el
        });
      });
    }
  });

module.exports = Accordion;



// WEBPACK FOOTER //
// ./assets/components/Accordion/Accordion.js